import { Http } from "@/util";

export function getOssUploadRole() {
  return Http.get("/admin/upload/role/grant");
}
